import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

const RecommendationSection = (props: { recommendedPercent: number; className: string }) => {
  const { recommendedPercent, className } = props;
  const roundedPercentage = Math.round(recommendedPercent);

  if (!roundedPercentage) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <div
      className={`uitk-type-200 ${className}`}
      dangerouslySetInnerHTML={{
        __html: formatText("destinationActivities.travellersRecommend", roundedPercentage),
      }}
    />
  );
};

export default RecommendationSection;
